import React from 'react'
import './OurMission.css';
function OurMission() {
    return (
        <div className='our-mission'>
            <div className='our-mission-wrapper'>
                <h2>Our Mission</h2>
                <p className='our-mission-p1'>"To promote socio-economic progress, environmental stewardship, and good governance through collaborative efforts, innovative solutions, and effective service delivery in partnership with all stakeholders."</p>
                <p>At Igbo-Eze North, we believe in <strong>planning with purpose and governing with accountability</strong>. From upgrading schools and healthcare centres to enhancing agricultural productivity and community safety, we are building a local government that works — for everyone.</p>
            </div>
        </div>
    )
}

export default OurMission;